/**
 * Icone di arma corta e arma lunga.
 *
 * Lucide non ha icone di armi (scelta della libreria), e usare `Crosshair` per
 * tutto rende indistinguibili pistola e carabina proprio dove la distinzione
 * conta: un atleta Tactical Games ne registra due e le sceglie a colpo d'occhio.
 *
 * Disegnate nello stile lucide — viewBox 24, tratto su `currentColor`,
 * `strokeWidth` 1.8, estremi arrotondati — così stanno accanto alle altre senza
 * stonare e ereditano colore e dimensione dal contesto.
 */

const base = (size) => ({
	xmlns: "http://www.w3.org/2000/svg",
	width: size,
	height: size,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
});

export function HandgunIcon({ size = 24, className = "", ...props }) {
	return (
		<svg {...base(size)} className={className} {...props}>
			{/* carrello */}
			<path d="M4 6h15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4z" />
			{/* impugnatura */}
			<path d="M9 10l-2.5 8H11l2-8" />
			{/* ponticello */}
			<path d="M13.5 10v1.5a2.5 2.5 0 0 0 2.5 2.5" />
		</svg>
	);
}

export function RifleIcon({ size = 24, className = "", ...props }) {
	return (
		<svg {...base(size)} strokeWidth={1.7} className={className} {...props}>
			{/* castello e canna */}
			<path d="M6 8h16v2.5H6z" />
			{/* calcio */}
			<path d="M6 8H2.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5H5l1-2.5z" />
			{/* impugnatura */}
			<path d="M10.5 10.5L9 15.5h2.5l1.5-5" />
			{/* caricatore */}
			<path d="M15 10.5l.8 5h2l-.8-5" />
		</svg>
	);
}

/**
 * L'icona giusta per un `firearm_type`.
 * Fucile e PCC ricadono sull'arma lunga: la silhouette è quella.
 */
export function firearmTypeIcon(firearmType) {
	return firearmType === "rifle" ||
		firearmType === "shotgun" ||
		firearmType === "pcc"
		? RifleIcon
		: HandgunIcon;
}
